import groq from 'groq'

export const HERO_VIDEO_QUERY = groq`
  *[_type == "heroVideo" && isActive == true][0] {
    _id,
    videoFile {
      asset->{
        _id,
        url,
        originalFilename,
        size
      }
    },
    posterImage {
      asset->{
        _id,
        url,
        metadata {
          dimensions {
            width,
            height
          }
        }
      }
    }
  }
`